module.exports = __webpack_public_path__ + "img/img-1.ec97979f.webp";